!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.modal = {
    attach: function(context) {
      const $modals = $('.modal', context);

      if (!$modals.length) {
        return;
      }

      $modals.each(function(index, $modal) {
        const $modalWrapper = $('.modal__content-wrapper', $modal);
        const $modalHeader = $('.modal__header', $modal);
        const $modalContent = $('.modal__content', $modal);
        const $modalToggleOpen = $('.modal__open-toggle', $modal);
        const $modalToggleClose = $('.modal__close-toggle', $modal);

        // Show Modal.
        $modalToggleOpen
          .on('click', function() {
            $modalWrapper.addClass('open');
            $($modal).addClass('open-overlay');

            if (!$modalContent.hasClass('digital-membership-card__content')) {
              $modalContent.css(
                'height',
                `calc(100% - ${$modalHeader.innerHeight()}px)`
              );
            }
          })
          .on('keydown', function(e) {
            // This happens only on space and enter.
            if (e.keyCode === 32 || e.keyCode === 13) {
              $modalWrapper.addClass('open');
              $($modal).addClass('open-overlay');

              if (!$modalContent.hasClass('digital-membership-card__content')) {
                $modalContent.css(
                  'height',
                  `calc(100% - ${$modalHeader.innerHeight()}px)`
                );
              }
            }
          });

        // Hide Modal.
        $modalToggleClose
          .on('click', function() {
            $modalWrapper.removeClass('open');
            $($modal).removeClass('open-overlay');
          })
          .on('keydown', function(e) {
            if (e.keyCode === 32 || e.keyCode === 13) {
              $modalWrapper.addClass('open');
              $($modal).addClass('open-overlay');
            }
          });

        $(document).on('click', function(e) {
          if ($($modal).is(e.target) && $($modal).has(e.target).length === 0) {
            $modalWrapper.removeClass('open');
            $($modal).removeClass('open-overlay');
          }
        });

        $(document).on('keydown', function(event) {
          if (event.keyCode === 27) {
            $modalWrapper.removeClass('open');
            $($modal).removeClass('open-overlay');
          }
        });
      });
    }
  };
})(Drupal, jQuery);
